export const harvestGenerateValue = 'generate'
export const harvestNurtureValue = 'crusade'
export const harvestClarityValue = 'clarity'
